<template>
  <div class="w-100pct">
    <b-overlay :show="busy" rounded="sm">
      <b-card>
        <b-card-group class="mt-2 px-1" deck>
          <b-card class="no-border px-2">
            <b-card-sub-title class="mt-2">
              Follow these steps to import your files:
            </b-card-sub-title>

            <b-card-text class="mt-1">
              <span
                >&bull; Add data to a file (use our template to get
                started).</span
              ><br />
              <span
                >&bull; Browse or drag and drop files to the cloud icon.</span
              ><br />
              <span>&bull; Click Upload to insert the data</span>
            </b-card-text>

            <b-row>
              <b-col>
                <div class="row">
                  <div class="col s12">
                    <div
                      class="fileuploader center-align text-center"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                    >
                      <input
                        type="file"
                        multiple
                        name="fields[assetsFieldHandle][]"
                        id="assetsFieldHandle"
                        class="w-px h-px opacity-0 overflow-hidden absolute"
                        @change="onChange"
                        ref="file"
                        style="display: none"

                      />
                        <!-- :accept="config.find((o) => o.key == 'accept').value" -->
                      <label
                        for="assetsFieldHandle"
                        class="block cursor-pointer"
                      >
                        <div
                          v-if="this.filelist.length == 0"
                          id="upload-label"
                          style="width: 200px"
                        >
                          <i class="fa fa-cloud-upload"></i>
                        </div>

                        <span class="tittle"
                          >Click the icon or drop files here</span
                        >
                      </label>

                      <!-- class="small" -->
                      <div v-if="this.filelist.length">
                        <table
                          class="
                            table table-sm
                            b-table
                            table-striped
                            flightstable
                            text-secondary
                            mb-0
                          "
                        >
                          <tbody>
                            <tr v-for="(file, index) in filelist" :key="index">
                              <td>{{ file.name }}</td>
                              <td>
                                {{
                                  file.lastModified
                                    | moment("DD/MM/YYYY HH:mm:ss")
                                }}
                              </td>
                              <td>{{ file.size | formatSize }}</td>
                              <td>
                                <b-button
                                  size="sm"
                                  class=""
                                  type="button"
                                  variant="link"
                                  @click="remove(filelist.indexOf(file))"
                                  title="Remove file"
                                >
                                  <i class="fa fa-times text-danger"></i>
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <b-row
                        no-gutters
                        class="text-sm my-1 mr-2"
                        align-h="end"
                        v-if="this.filelist.length > 0"
                      >
                        
                      </b-row> -->
                      </div>

                      <!-- <div class="small" v-if="this.filelist.length">
                      <b-row
                        no-gutters
                        align-v="center"
                        v-for="(file, index) in filelist"
                        :key="index"
                        class="text-sm px-0 py-0 text-secondary"
                      >
                        <b-col cols="auto">
                          <i class="fa fa-file ml-4 pr-1"></i
                          >{{ file.name }}</b-col
                        >
                        <b-col cols="auto" class="pl-2">
                          {{
                            file.lastModified | moment("DD/MM/YYYY HH:mm:ss")
                          }}</b-col
                        >
                        <b-col cols="2" class="text-right">
                          {{ file.size | formatSize }}</b-col
                        >
                        <b-col cols="auto" class="px-0">
                          <b-button
                            size="sm"
                            class=""
                            type="button"
                            variant="link"
                            @click="remove(filelist.indexOf(file))"
                            title="Remove file"
                          >
                            <i class="fa fa-times text-danger"></i> </b-button
                        ></b-col>
                      </b-row>
                      <b-row
                        no-gutters
                        class="text-sm my-1"
                        align-h="end"
                        v-if="this.filelist.length > 0"
                      >
                        <b-col cols="1" class="float-right">
                          <b-button-group size="sm">
                            <b-link
                              @click="
                                $refs.file.value = null;
                                filelist = [];
                              "
                            >
                              <i class="fa fa-trash fa-2x text-danger"></i>
                            </b-link>
                          </b-button-group>
                        </b-col>
                      </b-row>
                    </div> -->
                    </div>

                    <!-- Preview collection of uploaded documents -->
                    <!--    <div class="preview-container">
                  <div class="collection card" id="previews">
                    <div
                      class="
                        collection-item
                        clearhack
                        valign-wrapper
                        item-template
                      "
                      id="zdrop-template"
                    >
                      <div class="left pv zdrop-info" data-dz-thumbnail>
                        <div>
                          <span data-dz-name></span>
                          <span data-dz-size></span>
                        </div>
                        <div class="progress">
                          <div
                            class="determinate"
                            style="width: 0"
                            data-dz-uploadprogress
                          ></div>
                        </div>
                        <div class="dz-error-message">
                          <span data-dz-errormessage></span>
                        </div>
                      </div>

                      <div class="secondary-content actions">
                        <a
                          href="#!"
                          data-dz-remove
                          class="
                            btn-floating
                            ph
                            red
                            white-text
                            waves-effect waves-light
                          "
                          ><i class="material-icons white-text">clear</i></a
                        >
                      </div>
                    </div>
                  </div>
                </div> -->
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-card-footer class="px-3 mt-2">
              <b-row no-gutters>
                <b-col cols="10">
                  {{ filelist.length }} file(s) ready for upload.
                </b-col>
                <b-col cols="2" class="text-right pr-0">
                  <b-link
                    v-if="this.filelist.length > 0"
                    @click="
                      $refs.file.value = null;
                      filelist = [];
                    "
                  >
                    <i class="fa fa-trash fa-1x text-danger"></i>
                  </b-link>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
          <b-card no-body>
            <b-tabs pills card small>
              <b-tab title="Formats" active>
                <b-card class="no-border m-0">
                  <b-card-sub-title>
                    Fileformats you can import:
                  </b-card-sub-title>
                  <table
                    class="
                      table table-sm
                      b-table
                      table-striped
                      flightstable
                      mt-4
                    "
                  >
                    <thead>
                      <tr>
                        <th>Extension</th>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(fileformat, index) in fileformats"
                        :key="index"
                      >
                        <td>{{ fileformat.extension }}</td>
                        <td>{{ fileformat.name }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- {{ fileformats }} -->
                  <b-card-footer class="px-0">
                    <b-row>
                      <b-col cols="auto">
                        Download our
                        <!-- <b-link @click="download()">{{
                          config.find((o) => o.key == "layout").value
                        }}</b-link> -->
                        template to create your own data file.
                      </b-col>
                    </b-row>
                  </b-card-footer>
                </b-card></b-tab
              >
              <b-tab title="Options">
                <b-form-checkbox
                  id="headerrow"
                  v-model="headerrow"
                  name="headerrow"
                  value="true"
                  unchecked-value="false"
                >
                  <div style="padding-top: 4px">Header Row</div>
                </b-form-checkbox>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-card-group>
        <b-card-footer class="mt-2 ml-1">
          <b-row>
            <b-col class="text-left" cols="8">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <!-- <span v-html="config.find((o) => o.key == 'message').value"></span> -->
              </div>
            </b-col>
            <b-col class="text-right" cols="4">
              <b-button
                squared
                size="sm"
                variant="secondary"
                class="mr-1"
                @click="discard"
              >
                <i class="fa fa-chevron-left pr-1"></i>
              Back
              </b-button>
              <b-button
                :disabled="filelist.length > 0 ? false : true"
                squared
                size="sm"
                variant="primary"
                @click="upload"
              >
                <i class="fa fa-check"></i>
                Upload It
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import gql from "graphql-tag";

import ExcelJS from "exceljs";
import * as fs from "file-saver";

export default {
  name: "FilesUpload",
  data() {
    return {
      busy: false,
      headerrow: true,
      filelist: [], // Store our uploaded files
      fileformats: [],
      filelibrary: [
        {
          extension: ".xls",
          name: "Microsoft Excel worksheet sheet (97–2003)",
        },
        { extension: ".xlsx", name: "Office Open XML worksheet sheet" },
        { extension: ".csv", name: "Comma Delimited" },
        {
          extension: ".hot",
          name: "Hot Files",
        },
        { extension: ".xml", name: "XML File" },
      ],
    };
  },
  watch: {
    config: {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log("watch:config", newVal);

        if (newVal) {
          let fileaccept = newVal.find((o) => o.key == "accept").value;
          let list = fileaccept.split(",");
          for (var j = 0; j < list.length; j++) {
            let find = this.filelibrary.find((o) => o.extension == list[j]);
            if (find) {
              this.fileformats.push(find);
            }
          }
        }
      },
    },
  },
  methods: {
    async onChange() {
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();

      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
      event.currentTarget.classList.add("active");
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");

      event.currentTarget.classList.remove("active");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
      event.currentTarget.classList.remove("active");
    },
    async download() {
      let name = this.config.find((o) => o.key == "layout").value;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query templates($name: String) {
              templates(name: $name)
            }
          `,
          variables: {
            name,
          },
        });

        let workbook = new ExcelJS.Workbook();
        workbook.model = JSON.parse(response.data.templates);
        workbook.created = new Date();
        workbook.modified = new Date();
        let buffer = await workbook.xlsx.writeBuffer();
        fs.saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "template" + this.$moment().format("_YYYYMMDDHHMMSS") + ".xlsx"
        );
      } catch (error) {
        console.log(error);
      }
    },
    async upload() {
      let files = [];
      for (var j = 0; j < this.filelist.length; j++) {
        let file = this.filelist[j];
        let data = await this.$helpers.getBase64(this.filelist[j]);

        files.push({ name: file.name, data });
      }
      console.log("upload", files);
      this.$emit("fileit", files);
    },
  },
};
</script>

<style>
</style>